export const HomeworkStatus = {
  NEW: 'New',
  UPDATED: 'Updated',
  PUBLISHED: 'Published',
};

export default HomeworkStatus;



// WEBPACK FOOTER //
// ./data/Homework/status.js